import axios from "axios";
import { getToken } from "./auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function authHeader() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function recordRankingRound(points) {
  if (!getToken()) return null; // guest mode: no leaderboard
  const { data } = await axios.post(
    `${API}/ranking/round`,
    { points },
    { headers: authHeader() }
  );
  return data;
}

export async function fetchRanking(period = "weekly") {
  const { data } = await axios.get(`${API}/ranking?period=${period}`, {
    headers: authHeader(),
  });
  return data;
}

export async function setLeaderboardOptOut(optOut) {
  const { data } = await axios.put(
    `${API}/me/leaderboard`,
    { opt_out: !!optOut },
    { headers: authHeader() }
  );
  return data;
}
